import { EM_VALUE } from 'Constants';

const pxToEm = (
  size?: number | string,
  asNumber = false,
  defaultEmValue = EM_VALUE,
) => {
  // EM_VALUE (16.0) - is the value of 1 em this is adjustable
  if (size == null || isNaN(Number(size))) return size;
  if (asNumber) {
    return Number(size) / Number(defaultEmValue);
  }
  return `${Number(size) / Number(defaultEmValue)}em`;
};

export default pxToEm;
